<template>
    <div id="retail_delivery_report" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-if="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="customerHeader2">Create Retail Delivery Report</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goToListPage()">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div class="admin-page-content customer-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="needs-validation" novalidate id="VehicleOptionForm">
                                <div class="form-row">
                                    <div class="col-4 form-group">
                                        <label class="control-label">Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="date" name="date" v-model="date"
                                                :config="optionsDate" disabled></date-picker>
                                            <label for="date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                    </div>
                                </div>
                                <!-- CHASSIS INFORMATION FORM -->
                                <h3 style="font-size: 20px;" class="color-darkblue mt-3">
                                    <b>
                                        CHASSIS INFORMATION
                                    </b>
                                </h3>
                                <hr class="mt-1">
                                <div class="form-row">
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="model-year">Model Year:</label>
                                        <input type="text" @keypress="isNumberOnly" class="form-control"
                                            v-model.trim="modelYear" id="model-year" placeholder="Model Year"
                                            name="model-year" maxlength="4" :disabled="isEditPage">
                                        <span v-if="modelYearErrMsg" class="field-error">{{ modelYearErrMsg }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="model">Model:</label>
                                        <input type="text" class="form-control" v-model.trim="model" id="model"
                                            placeholder="Model" name="model" maxlength="50" :disabled="isEditPage">
                                        <span v-if="modelErrMsg" class="field-error">{{ modelErrMsg }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="wheelbase-length">Wheel base
                                            Length:</label>
                                        <input type="text" class="form-control" v-model.trim="wheelBaseLength"
                                            id="wheelbase-length" placeholder="Wheel base Length"
                                            name="wheelbase-length" maxlength="3" :disabled="isEditPage">
                                        <span v-if="wheelBaseLengthErrMsg" class="field-error">{{
                                            wheelBaseLengthErrMsg }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="vin">VIN:</label>
                                        <v-select v-model="vin" id="vehicle_id" name="vehicle_id" label="text"
                                            :filterable="false" :options="vinArr" @search="onSearchVehicle"
                                            @change="onVinChange" placeholder="Search VIN"
                                            class='custom-ci-auto-search close-remove' :disabled="isEditPage">
                                            <template slot="no-options">
                                                Search VIN...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <span v-if="vinErrMsg" class="field-error">{{
                                            vinErrMsg }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require">Delivery Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="delivery-date"
                                                name="delivery-date" v-model="deliveryDate" :config="optionsDate"
                                                :disabled="isEditPage"></date-picker>
                                            <label for="delivery-date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div v-if="deliveryDateErrMsg" class="field-error">{{ deliveryDateErrMsg }}
                                        </div>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="odometer">Odometer at
                                            Delivery:</label>
                                        <input type="text" @keypress="isNumberOnly" class="form-control"
                                            v-model.trim="odometer" maxlength="10" id="odometer"
                                            placeholder="Odometer at Delivery" name="odometer" :disabled="isEditPage">
                                        <span v-if="odometerErrMsg" class="field-error">{{ odometerErrMsg }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="body-type">Body Type:</label>
                                        <input type="text" class="form-control" v-model.trim="bodyType" id="body-type"
                                            placeholder="Body Type" maxlength="50" name="body-type"
                                            :disabled="isEditPage">
                                        <span v-if="bodyTypeErrMsg" class="field-error">{{
                                            bodyTypeErrMsg }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="primary-body-builder-name">Primary
                                            Body Builder Name:</label>
                                        <input type="text" class="form-control" v-model.trim="primaryBodyBuilderName"
                                            id="primary-body-builder-name" maxlength="50"
                                            placeholder="Primary Body Builder Name" name="primary-body-builder-name"
                                            :disabled="isEditPage">
                                        <span v-if="primaryBodyBuilderNameErrMsg" class="field-error">{{
                                            primaryBodyBuilderNameErrMsg }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require">Rizon Connect Authorization:</label>
                                        <v-select class="close-remove" v-model="rizonConnectAuthorization"
                                            id="rizon-connect-authorization" name="rizon-connect-authorization"
                                            placeholder="Select..." @change="rizonConnectAuthorizationChanged($event)"
                                            label="text" :searchable="false" :disabled="isEditPage"
                                            :options="['Yes', 'No']">
                                        </v-select>
                                        <span v-if="rizonConnectAuthorizationErrMsg" class="field-error">{{
                                            rizonConnectAuthorizationErrMsg }}</span>
                                    </div>
                                </div>
                                <!-- CHASSIS INFORMATION FORM END-->

                                <!-- CUSTOMER INFORMATION FORM -->
                                <h3 style="font-size: 20px;" class="color-darkblue mt-3">
                                    <b>
                                        CUSTOMER INFORMATION
                                    </b>
                                </h3>
                                <hr class="mt-1">
                                <div class="form-row">
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="customer-name">Customer Name:</label>
                                        <v-select v-model="customerName" name="customer-name" label="text"
                                            :filterable="false" :options="consumerArr" @search="onSearchConsumer"
                                            @change="onConsumerChange($event)" placeholder="Search Customer"
                                            class='custom-ci-auto-search close-remove' :disabled="isEditPage">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <span v-if="customerNameErrMsg" class="field-error">{{ customerNameErrMsg
                                            }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="company-name">Company Name:</label>
                                        <input type="text" class="form-control" v-model.trim="companyName"
                                            id="company-name" placeholder="Company Name" name="company-name"
                                            :disabled="true">
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="business-type">Business Type:</label>
                                        <input type="text" class="form-control" maxlength="50"
                                            v-model.trim="businessType" id="business-type" placeholder="Business Type"
                                            name="business-type" :disabled="isEditPage">
                                        <span v-if="businessTypeErrMsg" class="field-error">{{ businessTypeErrMsg
                                            }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="customer-address">Address:</label>
                                        <input type="text" class="form-control" v-model.trim="customerAddress"
                                            id="customer-address" placeholder="Address" name="customer-address"
                                            :disabled="true">
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="customer-city">City:</label>
                                        <input type="text" class="form-control" v-model.trim="customerCity"
                                            id="customer-city" placeholder="City" name="customer-city" :disabled="true">
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="customer-state">State:</label>
                                        <input type="text" class="form-control" v-model.trim="customerState"
                                            id="customer-state" placeholder="State" name="customer-state"
                                            :disabled="true">
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="customer-zip">Zip:</label>
                                        <input type="text" class="form-control" v-model.trim="customerZip"
                                            id="customer-zip" placeholder="Zip" name="customer-zip" :disabled="true">
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="customer-email">Customer
                                            Email:</label>
                                        <input type="text" class="form-control" v-model.trim="customerEmail"
                                            id="customer-email" placeholder="Customer Email" name="customer-email"
                                            :disabled="true">
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="customer-phone">Customer
                                            Phone #:</label>
                                        <input type="text" class="form-control"
                                            v-cleave="{ delimiter: '-', blocks: [3, 3, 4] }"
                                            v-model="customerPhoneNumber" placeholder="Customer Phone Number"
                                            ref="phoneInput" name="customer-phone" @keypress="isNumber($event)"
                                            :disabled="true">
                                    </div>
                                </div>
                                <!-- CUSTOMER INFORMATION FORM END-->

                                <!-- DEALERSHIP INFORMATION FORM -->
                                <h3 style="font-size: 20px;" class="color-darkblue mt-3">
                                    <b>
                                        DEALERSHIP INFORMATION
                                    </b>
                                </h3>
                                <hr class="mt-1">
                                <div class="form-row">
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="dealer-name">Dealer Name:</label>
                                        <v-select v-model="dealerName" name="dealer-name" label="text"
                                            :filterable="false" :options="dealerArr" @change="onDealerChange($event)"
                                            placeholder="Select Dealer" class='custom-ci-auto-search close-remove'
                                            :disabled="isEditPage">
                                            <template slot="no-options">
                                                Select Dealer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <span v-if="dealerNameErrMsg" class="field-error">{{ dealerNameErrMsg
                                            }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="dealer-code">Dealer Code:</label>
                                        <input type="text" class="form-control" v-model.trim="dealerCode"
                                            id="dealer-code" placeholder="Dealer Code" name="dealer-code"
                                            :disabled="true">
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="dealer-address">Address:</label>
                                        <input type="text" class="form-control" v-model.trim="dealerAddress"
                                            id="dealer-address" placeholder="Address" name="dealer-address"
                                            :disabled="true">
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="dealer-city">City:</label>
                                        <input type="text" class="form-control" v-model.trim="dealerCity"
                                            id="dealer-city" placeholder="City" name="dealer-city" :disabled="true">
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="dealer-state">State:</label>
                                        <input type="text" class="form-control" v-model.trim="dealerState"
                                            id="dealer-state" placeholder="State" name="dealer-state" :disabled="true">
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label" for="dealer-zip">Zip:</label>
                                        <input type="text" class="form-control" v-model.trim="dealerZip" id="dealer-zip"
                                            placeholder="Zip" name="dealer-zip" :disabled="true">
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="salesperson-first-name">Salesperson
                                            First
                                            Name:</label>
                                        <input type="text" class="form-control" v-model.trim="salespersonFirstName"
                                            id="salesperson-first-name" placeholder="Salesperson First Name"
                                            name="salesperson-first-name" maxlength="50" :disabled="isEditPage">
                                        <span v-if="salespersonFirstNameErrMsg" class="field-error">{{
                                            salespersonFirstNameErrMsg
                                        }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="salesperson-last-name">Salesperson
                                            Last
                                            Name:</label>
                                        <input type="text" class="form-control" v-model.trim="salespersonLastName"
                                            id="salesperson-last-name" maxlength="50"
                                            placeholder="Salesperson Last Name" name="salesperson-last-name"
                                            :disabled="isEditPage">
                                        <span v-if="salespersonLastNameErrMsg" class="field-error">{{
                                            salespersonLastNameErrMsg
                                        }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="salesperson-email">Salesperson
                                            Email:</label>
                                        <input type="text" class="form-control" v-model.trim="salespersonEmail"
                                            id="salesperson-email" maxlength="100" placeholder="Salesperson Email"
                                            name="salesperson-email" :disabled="isEditPage">
                                        <span v-if="salespersonEmailErrMsg" class="field-error">{{
                                            salespersonEmailErrMsg
                                        }}</span>
                                    </div>
                                    <div class="col-4 form-group">
                                        <label class="control-label require" for="salesperson-phone">Salesperson
                                            Phone #:</label>
                                        <input type="text" class="form-control"
                                            v-cleave="{ delimiter: '-', blocks: [3, 3, 4] }"
                                            v-model="salespersonPhoneNumber" placeholder="Salesperson Phone Number"
                                            ref="phoneInput" name="salesperson-phone" @keypress="isNumber($event)"
                                            :disabled="isEditPage">
                                        <span v-if="salespersonPhoneNumberErrMsg" class="field-error">{{
                                            salespersonPhoneNumberErrMsg
                                        }}</span>
                                    </div>
                                </div>
                                <!-- DEALERSHIP INFORMATION FORM END-->

                                <p class="font-bold mt-3">
                                    All above requested information must be correctly provided in order for this chassis
                                    to be Warranty registered with
                                    RIZON.
                                    Including a signed customer RIZONConnect agreement form. Failure to provide correct
                                    information may result in denial
                                    of Warranty consideration,
                                    as well as Dealer Salesperson ineligibility for any applicable RIZON Sales Incentive
                                    Program awards which may apply
                                    to this customer retail delivery.
                                </p>

                                <div v-if="!isEditPage" class="btn-groups text-right mt-4">
                                    <button type="submit" id="createReportBtn" class="btn btn-primary"
                                        v-on:click.prevent="validateAllFields()">
                                        <i class="fp-save"> </i> <strong>SUBMIT</strong>
                                    </button>
                                </div>
                            </form>
                        </section>

                        <section v-if="isEditPage && showInternalSection"
                            class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="needs-validation" novalidate id="VehicleOptionForm">
                                <!-- RDR Internal Fields -->
                                <div v-if="rdrInternalFields">
                                    <h3 style="font-size: 20px;" class="color-darkblue">
                                        <b>
                                            RDR Internal
                                        </b>
                                    </h3>
                                    <div class="form-row">
                                        <div class="col-4 form-group">
                                            <label class="control-label require" for="rdr-internal-verified-by">Verified
                                                By:</label>
                                            <input type="text" class="form-control" v-model.trim="rdrInternalVerifiedBy"
                                                id="rdr-internal-verified-by" disabled placeholder="Verified By"
                                                name="rdr-internal-verified-by">
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require">Verification Date:</label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="rdr-internal-vefication-date"
                                                    name="rdr-internal-vefication-date" v-model="rdrVerificationDate"
                                                    :config="optionsDate"></date-picker>
                                                <label for="rdr-internal-vefication-date"
                                                    class="fp-calendar input-calender-icon"></label>
                                            </div>
                                            <span v-if="rdrVerificationDateErrMsg" class="field-error">{{
                                                rdrVerificationDateErrMsg }}</span>
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require">Incentive Program Used?:</label>
                                            <v-select class="close-remove" v-model="rdrInternalIncentiveProgram"
                                                id="rdr-internal-incentive-program"
                                                name="rdr-internal-incentive-program" placeholder="Select..."
                                                @change="rdrInternalIncentiveProgramChanged($event)" label="text"
                                                :searchable="false" :options="['Yes', 'No']">
                                            </v-select>
                                            <span v-if="rdrInternalIncentiveProgramErrMsg" class="field-error">{{
                                                rdrInternalIncentiveProgramErrMsg }}</span>
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require" for="rdr-internal-program-name">Program
                                                Name:</label>
                                            <input type="text" class="form-control"
                                                v-model.trim="rdrInternalProgramName" id="rdr-internal-program-name"
                                                placeholder="Program Name" maxlength="100"
                                                name="rdr-internal-program-name">
                                            <span v-if="rdrInternalProgramNameErrMsg" class="field-error">{{
                                                rdrInternalProgramNameErrMsg }}</span>
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require"
                                                for="rdr-internal-program-number">Program
                                                Number:</label>
                                            <input type="text" class="form-control"
                                                v-model.trim="rdrInternalProgramNumber" id="rdr-internal-program-number"
                                                placeholder="Program Number" maxlength="25"
                                                name="rdr-internal-program-number">
                                            <span v-if="rdrInternalProgramNumberErrMsg" class="field-error">{{
                                                rdrInternalProgramNumberErrMsg }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- Rizon Connect Log Fields -->
                                <div v-if="rizonConnectLogFields">
                                    <h3 style="font-size: 20px;" class="color-darkblue">
                                        <b>
                                            Rizon Connect Log
                                        </b>
                                    </h3>
                                    <div class="form-row">
                                        <div class="col-4 form-group">
                                            <label class="control-label require" for="rizon-log-company-name">Company
                                                Name:</label>
                                            <input type="text" class="form-control" v-model.trim="rizonLogCompanyName"
                                                id="rizon-log-company-name" maxlength="100" placeholder="Company Number"
                                                name="rizon-log-company-name">
                                            <span v-if="rizonLogCompanyNameErrMsg" class="field-error">{{
                                                rizonLogCompanyNameErrMsg }}</span>
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require" for="rizon-log-customer-name">Customer
                                                Name:</label>
                                            <input type="text" class="form-control" maxlength="100"
                                                v-model.trim="rizonLogCustomerName" id="rizon-log-customer-name"
                                                placeholder="Customer Name" name="rizon-log-customer-name">
                                            <span v-if="rizonLogCustomerNameErrMsg" class="field-error">{{
                                                rizonLogCustomerNameErrMsg }}</span>
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require">Signature Collected?:</label>
                                            <v-select class="close-remove" v-model="rizonLogSignatureCollected"
                                                id="rizon-log-signature" name="rizon-log-signature"
                                                placeholder="Select..."
                                                @change="rizonLogSignatureCollectedChanged($event)" label="text"
                                                :searchable="false" :options="['Yes', 'No']">
                                            </v-select>
                                            <span v-if="rizonLogSignatureCollectedErrMsg" class="field-error">{{
                                                rizonLogSignatureCollectedErrMsg }}</span>
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require" for="rizon-log-customer-email">Customer
                                                Email:</label>
                                            <input type="text" class="form-control" v-model.trim="rizonLogCustomerEmail"
                                                id="rizon-log-customer-email" placeholder="Customer Email"
                                                name="rizon-log-customer-email">
                                            <span v-if="rizonLogCustomerEmailErrMsg" class="field-error">{{
                                                rizonLogCustomerEmailErrMsg }}</span>
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require" for="rizon-log-customer-phone">Customer
                                                Phone:</label>
                                            <input type="text" class="form-control"
                                                v-cleave="{ delimiter: '-', blocks: [3, 3, 4] }"
                                                v-model="rizonLogCustomerPhone" placeholder="Customer Phone Number"
                                                ref="phoneInput" name="rizon-log-customer-phone"
                                                @keypress="isNumber($event)">
                                            <span v-if="rizonLogCustomerPhoneErrMsg" class="field-error">{{
                                                rizonLogCustomerPhoneErrMsg
                                                }}</span>
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require">Date Signed:</label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="rizon-log-date-signed"
                                                    name="rizon-log-date-signed" v-model="rizonLogDateSigned"
                                                    :config="optionsDate"></date-picker>
                                                <label for="rizon-log-date-signed"
                                                    class="fp-calendar input-calender-icon"></label>
                                            </div>
                                            <span v-if="rizonLogDateSignedErrMsg" class="field-error">{{
                                                rizonLogDateSignedErrMsg }}</span>
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require" for="rizon-log-document-link">Document
                                                Link:</label>
                                            <input type="url" class="form-control" maxlength="1000"
                                                v-model.trim="rizonLogDocumentLink" id="rizon-log-document-link"
                                                placeholder="Document Link" name="rizon-log-document-link">
                                            <span v-if="rizonLogDocumentLinkErrMsg" class="field-error">{{
                                                rizonLogDocumentLinkErrMsg }}</span>
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require">Reg Date:</label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="rizon-log-reg-date"
                                                    name="rizon-log-reg-date" v-model="rizonLogRegDate"
                                                    :config="optionsDate"></date-picker>
                                                <label for="rizon-log-reg-date"
                                                    class="fp-calendar input-calender-icon"></label>
                                            </div>
                                            <span v-if="rizonLogRegDateErrMsg" class="field-error">{{
                                                rizonLogRegDateErrMsg }}</span>
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require">Exp Date:</label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="rizon-log-exp-date"
                                                    name="rizon-log-exp-date" v-model="rizonLogExpDate"
                                                    :config="optionsDate"></date-picker>
                                                <label for="rizon-log-exp-date"
                                                    class="fp-calendar input-calender-icon"></label>
                                            </div>
                                            <span v-if="rizonLogExpDateErrMsg" class="field-error">{{
                                                rizonLogExpDateErrMsg }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- Rizon Connect Internal Fields -->
                                <div v-if="rizonConnectInternalFields">
                                    <h3 style="font-size: 20px;" class="color-darkblue">
                                        <b>
                                            Rizon Connect Internal
                                        </b>
                                    </h3>
                                    <div class="form-row">
                                        <div class="col-4 form-group">
                                            <label class="control-label require"
                                                for="rizon-connect-verified-by">Verified
                                                By:</label>
                                            <input type="text" class="form-control"
                                                v-model.trim="rizonConnectVerifiedBy" id="rizon-connect-verified-by"
                                                disabled placeholder="Verified By" name="rizon-connect-verified-by">
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require">Verification Date:</label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="rizon-connect-vefication-date"
                                                    name="rizon-connect-vefication-date"
                                                    v-model="rizonConnectVerificationDate"
                                                    :config="optionsDate"></date-picker>
                                                <label for="rizon-connect-vefication-date"
                                                    class="fp-calendar input-calender-icon"></label>
                                            </div>
                                            <span v-if="rizonConnectVerificationDateErrMsg" class="field-error">{{
                                                rizonConnectVerificationDateErrMsg }}</span>
                                        </div>
                                        <div class="col-4 form-group">
                                            <label class="control-label require" maxlength="100"
                                                for="rizon-connect-cust-admin">Cust
                                                Admin:</label>
                                            <input type="text" class="form-control" v-model.trim="rizonConnectCustAdmin"
                                                id="rizon-connect-cust-admin" placeholder="Cust Admin"
                                                name="rizon-connect-cust-admin">
                                            <span v-if="rizonConnectCustAdminErrMsg" class="field-error">{{
                                                rizonConnectCustAdminErrMsg }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="btn-groups text-right mt-4">
                                    <button type="submit" id="createReportBtn" class="btn btn-primary"
                                        v-on:click.prevent="validateAllRizonFields()">
                                        <strong>Save</strong>
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
                <div class="modal fade" id="uploadRizonConnect" tabindex="-1" role="dialog"
                    aria-labelledby="uploadRizonConnectLabel" data-backdrop="static">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div style="display: flex; justify-content: center; align-items: center;" class="mt-4 mb-3">
                                <img :src="logoPath" alt="Dealer Pro" style="height: 70px; margin-right: 7px">
                            </div>
                            <div class="pl-5 pr-5 mt-1">
                                <h4><strong>Rizon Connect Registration</strong></h4>
                                <DropZone :showUploadedFiles="false" :maxFileLimit='1' :docErrorMsg="docErrMsg"
                                    :dropzoneRequired="true" :dropZonePreviewFiles="[]" :dropzoneCol="'col-md-12'"
                                    :fileSizeLimit="20"
                                    :dropzoneLabel="'Upload the signed Rizon Connect terms & conditions'"
                                    @dropzone-update-files="updateFiles" />
                            </div>
                            <div class="d-flex justify-content-around mt-4 mb-3">
                                <button type="button" @click="uploadRizonConnectRegistration()"
                                    class="btn-lg btn-primary" style="width: 150px;">Upload
                                </button>
                                <button type="button" @click="closeRizonConnectUploadModal()" class="btn-lg btn-primary"
                                    style="width: 150px;">Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import { commonMixins } from '../../mixins/commonMixins';
import { contractMixins } from '../../mixins/contractMixins';

import moment from 'moment';

import DropZone from '../DropZone.vue';

export default {
    name: "RetailDeliveryReportCreate",
    components: { DropZone },
    metaInfo() {
        return {
            title: "Create Retail Delivery Report | " + process.env.COPYRIGHT_NAME
        }
    },
    mixins: [commonMixins, contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading: false,
        isEditPage: false,
        date: '',
        optionsDate: {
            format: 'MM/DD/YYYY'
        },
        reportId: 0,
        reportInternalId: 0,
        userObj: '',
        rizonConnect: false,

        modelYear: '',
        modelYearErrMsg: '',
        model: '',
        modelErrMsg: '',
        wheelBaseLength: '',
        wheelBaseLengthErrMsg: '',
        vin: '',
        vinErrMsg: '',
        vinArr: [],
        deliveryDate: '',
        deliveryDateErrMsg: '',
        odometer: '',
        odometerErrMsg: '',
        bodyType: '',
        bodyTypeErrMsg: '',
        primaryBodyBuilderName: '',
        primaryBodyBuilderNameErrMsg: '',
        rizonConnectAuthorization: '',
        rizonConnectAuthorizationErrMsg: '',

        customerName: '',
        customerNameErrMsg: '',
        consumerArr: [],
        companyName: '',
        businessType: '',
        businessTypeErrMsg: '',
        customerAddress: '',
        customerCity: '',
        customerState: '',
        customerZip: '',
        customerEmail: '',
        customerPhoneNumber: '',

        dealerArr: [],
        dealerCode: '',
        dealerName: '',
        dealerNameErrMsg: '',
        dealerAddress: '',
        dealerCity: '',
        dealerState: '',
        dealerZip: '',
        salespersonFirstName: '',
        salespersonFirstNameErrMsg: '',
        salespersonLastName: '',
        salespersonLastNameErrMsg: '',
        salespersonEmail: '',
        salespersonEmailErrMsg: '',
        salespersonPhoneNumber: '',
        salespersonPhoneNumberErrMsg: '',

        docErrMsg: "",
        files: [],
        logoPath: '',

        showInternalSection: false,
        rdrInternalFields: false,
        rizonConnectLogFields: false,
        rizonConnectInternalFields: false,

        rdrInternalVerifiedBy: '',
        rdrVerificationDate: '',
        rdrVerificationDateErrMsg: '',
        rdrInternalIncentiveProgram: '',
        rdrInternalIncentiveProgramErrMsg: '',
        rdrInternalProgramName: '',
        rdrInternalProgramNameErrMsg: '',
        rdrInternalProgramNumber: '',
        rdrInternalProgramNumberErrMsg: '',

        rizonLogCompanyName: '',
        rizonLogCompanyNameErrMsg: '',
        rizonLogCustomerName: '',
        rizonLogCustomerNameErrMsg: '',
        rizonLogSignatureCollected: '',
        rizonLogSignatureCollectedErrMsg: '',
        rizonLogCustomerEmail: '',
        rizonLogCustomerEmailErrMsg: '',
        rizonLogCustomerPhone: '',
        rizonLogCustomerPhoneErrMsg: '',
        rizonLogDateSigned: '',
        rizonLogDateSignedErrMsg: '',
        rizonLogDocumentLink: '',
        rizonLogDocumentLinkErrMsg: '',
        rizonLogRegDate: '',
        rizonLogRegDateErrMsg: '',
        rizonLogExpDate: '',
        rizonLogExpDateErrMsg: '',

        rizonConnectVerifiedBy: '',
        rizonConnectVerificationDate: '',
        rizonConnectVerificationDateErrMsg: '',
        rizonConnectCustAdmin: '',
        rizonConnectCustAdminErrMsg: '',
    }),

    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (
                        permissions[i].name == 'ev_create_retail_delivery_report'
                        ||
                        permissions[i].name == 'ev_edit_retail_delivery_report'
                    ) {
                        self.cantAccessPage = true;
                    }
                    if (
                        permissions[i].name == 'ev_rdr_internal_fields'
                    ) {
                        self.showInternalSection = true;
                        self.rdrInternalFields = true;
                    }
                    if (
                        permissions[i].name == 'ev_rizon_connect_log_fields'
                    ) {
                        self.showInternalSection = true;
                        self.rizonConnectLogFields = true;
                    }
                    if (
                        permissions[i].name == 'ev_rizon_connect_internal_fields'
                    ) {
                        self.showInternalSection = true;
                        self.rizonConnectInternalFields = true;
                    }
                }
            }
        }
    },
    created: function () {
        this.logoPath = process.env.LOGO_PATH;
    },
    mounted: function () {
        var self = this;
        self.userObj = JSON.parse(localStorage.getItem('user_obj'));
        self.getPermissions();
        self.date = moment().format('MM/DD/YYYY');

        if (
            self.$route.params.id !== undefined
            &&
            self.$route.params.id > 0
        ) {
            self.reportId = self.$route.params.id;
            self.isEditPage = true;
            self.loadSingleReport();
            self.populateInitialFields();
        }

        if (!self.isEditPage) {
            self.loadUserDealerMapper(self.userObj.id);
        }
    },
    methods: {
        updateFiles(files) {
            this.files = files;
        },
        goToListPage() {
            this.$router.push('/retail-delivery-report/list');
        },
        onSearchConsumer(search, loading) {
            var self = this;
            if (search.length > 2) {
                loading(true);
                self.searchField(loading, search, 'user_consumers');
            }
        },
        onConsumerChange(value) {
            if (value) {
                if (!this.isEditPage) {
                    const { address_line_1, city, state, zip, phone, email, company_name } = value;
                    this.customerAddress = address_line_1;
                    this.customerCity = city;
                    this.customerState = state;
                    this.customerZip = zip;
                    this.customerPhoneNumber = phone;
                    this.customerEmail = email;
                    this.companyName = company_name;
                }
            } else {
                this.clearCustomerInfo();
            }
        },
        clearCustomerInfo() {
            this.customerAddress = '';
            this.customerCity = '';
            this.customerState = '';
            this.customerZip = '';
            this.customerPhoneNumber = '';
            this.customerEmail = '';
        },
        onDealerChange(value) {
            if (value) {
                if (!this.isEditPage) {
                    const { code, address_line_1, city, state, zip } = value;
                    this.dealerCode = code;
                    this.dealerAddress = address_line_1;
                    this.dealerCity = city;
                    this.dealerState = state;
                    this.dealerZip = zip;
                }
            } else {
                this.clearDealerInfo();
            }
        },
        clearDealerInfo() {
            this.dealerCode = '';
            this.dealerAddress = '';
            this.dealerCity = '';
            this.dealerState = '';
            this.dealerZip = '';
        },
        populateInitialFields() {
            this.rdrInternalVerifiedBy = this.userObj.email || this.userObj.username;
            this.rdrVerificationDate = moment().format('MM/DD/YYYY');
            this.rizonConnectVerifiedBy = this.userObj.email || this.userObj.username;
            this.rizonConnectVerificationDate = moment().format('MM/DD/YYYY');
        },
        onSearchVehicle(search, loading) {
            var self = this;
            if (search.length > 3) {
                if (typeof loading === 'function') {
                    loading(true);
                } else {
                    self.loading = true;
                }
                self.searchField(loading, search, 'vehicle_vin');
            }
        },
        onVinChange(newValue) {
            if (
                newValue == null
                ||
                newValue == ''
            ) {
                this.vin = '';
                this.vinArr = [];
            }
        },
        rizonConnectAuthorizationChanged(newValue) {
            if (
                newValue == null
                ||
                newValue == ''
            ) {
                this.rizonConnectAuthorization = '';
            }
        },
        rdrInternalIncentiveProgramChanged(newValue) {
            if (
                newValue == null
                ||
                newValue == ''
            ) {
                this.rdrInternalIncentiveProgram = '';
            }
        },
        rizonLogSignatureCollectedChanged(newValue) {
            if (
                newValue == null
                ||
                newValue == ''
            ) {
                this.rizonLogSignatureCollected = '';
            }
        },
        validateAllFields() {
            var self = this;
            var success = true;

            self.clearErrMsg();

            if (self.modelYear == '') {
                self.modelYearErrMsg = 'Model Year is required.';
                success = false;
            }
            if (self.model == '') {
                self.modelErrMsg = 'Model is required.';
                success = false;
            }
            if (self.wheelBaseLength == '') {
                self.wheelBaseLengthErrMsg = 'Wheel base Length is required.';
                success = false;
            }
            if (self.vin == '' || self.vin == null) {
                self.vinErrMsg = 'VIN is required.';
                success = false;
            }
            if (self.deliveryDate == '' || self.deliveryDate == null) {
                self.deliveryDateErrMsg = 'Delivery Date is required.';
                success = false;
            }
            if (self.odometer == '') {
                self.odometerErrMsg = 'Odometer at Delivery is required.';
                success = false;
            }
            if (self.bodyType == '') {
                self.bodyTypeErrMsg = 'Body Type is required.';
                success = false;
            }
            if (self.primaryBodyBuilderName == '') {
                self.primaryBodyBuilderNameErrMsg = 'Primary Body Builder Name is required.';
                success = false;
            }
            if (self.rizonConnectAuthorization == '' || self.rizonConnectAuthorization == null) {
                self.rizonConnectAuthorizationErrMsg = 'Rizon Connect Authorization is required.';
                success = false;
            }
            if (self.customerName == '' || self.customerName == null) {
                self.customerNameErrMsg = 'Customer is required.';
                success = false;
            }
            if (self.businessType == '') {
                self.businessTypeErrMsg = 'Business Type is required.';
                success = false;
            }
            if (self.dealerName == '' || self.dealerName == null) {
                self.dealerNameErrMsg = 'Dealer is required.';
                success = false;
            }
            if (self.salespersonFirstName == '') {
                self.salespersonFirstNameErrMsg = 'Salesperson First Name is required.';
                success = false;
            }
            if (self.salespersonLastName == '') {
                self.salespersonLastNameErrMsg = 'Salesperson Last Name is required.';
                success = false;
            }
            if (self.salespersonEmail == '') {
                self.salespersonEmailErrMsg = 'Salesperson Email is required.';
                success = false;
            } else {
                if (!self.validEmail(self.salespersonEmail)) {
                    self.salespersonEmailErrMsg = 'Invalid Email Address.';
                    success = false;
                }
            }
            if (self.salespersonPhoneNumber == '') {
                self.salespersonPhoneNumberErrMsg = 'Salesperson Phone Number is required.';
                success = false;
            } else {
                var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if (!self.salespersonPhoneNumber.match(phoneRE)) {
                    self.salespersonPhoneNumberErrMsg = "Please enter valid phone number";
                    success = false;
                }
            }

            if (success) {
                self.handleSwalPopUps();
            } else {
                self.errorValidationFocus();
            }
        },
        handleSwalPopUps() {
            this.$swal({
                title: 'Would you like to register this vehicle with Rizon Connect?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                allowOutsideClick: false
            }).then((result) => {
                if (result.value) {
                    this.rizonConnect = true;
                    $('#uploadRizonConnect').modal('show');
                    // Save the data
                    this.createRetailDeliveryReport();
                } else {
                    this.rizonConnect = false;
                    // Save the data
                    this.createRetailDeliveryReport();
                }
            });
        },
        thankYouSwalPopUp() {
            this.$swal({
                title: 'Thank You!',
                text: 'Your Registration Has Been Received and Will Be Processed by the Rizon Team.',
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'Close',
                allowOutsideClick: false
            }).then((result) => {
                if (result.value) {
                    this.goToListPage();
                } else {
                    this.goToListPage();
                }
            });
        },
        createRetailDeliveryReport(flag = '') {
            var self = this;
            self.loading = true;

            var formData = self.generateFormData(flag);
            $.ajax({
                url: process.env.ROOT_API + "/retail-delivery-report/create",
                type: "POST",
                headers: this.ajxHeaders,
                data: formData,
                contentType: false,
                processData: false,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == 'success') {
                        if (!self.rizonConnect) {
                            self.thankYouSwalPopUp();
                        } else if (flag == 'upload-file') {
                            self.closeRizonConnectUploadModal();
                            self.thankYouSwalPopUp();
                        } else {
                            self.reportId = data.content.id;
                        }
                    }
                },
                error: function (jqXHR) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'create-retail-delivery-report');
                }
            });
        },
        generateFormData(flag) {
            var self = this;
            var formData = new FormData();

            if (flag == 'upload-file') {
                formData.append('files', self.files);
                formData.append('reportId', self.reportId);
            } else {
                formData.append('model_year', self.modelYear);
                formData.append('model', self.model);
                formData.append('wheel_base_length', self.wheelBaseLength);
                formData.append('vehicle_id', self.vin.value);
                formData.append('delivery_date', moment(self.deliveryDate).format('YYYY-MM-DD'));
                formData.append('odometer', self.odometer);
                formData.append('body_type', self.bodyType);
                formData.append('primary_body_builder_name', self.primaryBodyBuilderName);
                formData.append('rizon_connect_authorization', self.rizonConnectAuthorization === 'Yes' ? 1 : 0);

                formData.append('business_type', self.businessType);
                formData.append('consumer_id', self.customerName.value);

                formData.append('customer_id', self.dealerName.value);
                formData.append('salesperson_first_name', self.salespersonFirstName);
                formData.append('salesperson_last_name', self.salespersonLastName);
                formData.append('salesperson_email', self.salespersonEmail);
                formData.append('salesperson_phone_number', self.salespersonPhoneNumber);

                formData.append('created_by', self.userObj.id);
            }
            formData.append('rizon_connect', self.rizonConnect ? 1 : 0);

            return formData;
        },
        clearErrMsg() {
            var self = this;

            self.modelYearErrMsg = '';
            self.modelErrMsg = '';
            self.wheelBaseLengthErrMsg = '';
            self.vinErrMsg = '';
            self.deliveryDateErrMsg = '';
            self.odometerErrMsg = '';
            self.bodyTypeErrMsg = '';
            self.primaryBodyBuilderNameErrMsg = '';
            self.rizonConnectAuthorizationErrMsg = '';
            self.customerNameErrMsg = '';
            self.businessTypeErrMsg = '';
            self.dealerNameErrMsg = '';
            self.salespersonFirstNameErrMsg = '';
            self.salespersonLastNameErrMsg = '';
            self.salespersonEmailErrMsg = '';
            self.salespersonPhoneNumberErrMsg = '';
        },
        uploadRizonConnectRegistration() {
            this.docErrMsg = '';
            if (this.files.length > 0) {
                this.createRetailDeliveryReport('upload-file');
            } else {
                this.docErrMsg = 'Please upload the signed Rizon Connect terms & conditions.';
            }
        },
        closeRizonConnectUploadModal(flag = '') {
            this.docErrMsg = '';
            this.files = [];

            $('#uploadRizonConnect').modal('hide');
            this.showRizonConnectUploadCancelPopUp();
        },
        showRizonConnectUploadCancelPopUp() {
            this.$swal({
                title: 'Are you sure you want to cancel the Rizon Connect Registration?',
                text: 'Your RDR has already been saved',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                allowOutsideClick: false
            }).then((result) => {
                if (result.value) {
                    this.sendEmailNotification();
                } else {
                    $('#uploadRizonConnect').modal('show');
                }
            });
        },
        validateAllRizonFields() {
            var self = this;
            var overallSuccess = true;

            if (self.rdrInternalFields) {
                self.clearRDRInternalErrMsg();
                if (!self.validateRDRInternalFields()) {
                    overallSuccess = false;
                }
            }
            if (self.rizonConnectLogFields) {
                self.clearRizonLogErrMsg();
                if (!self.validateRizonConnectLogFields()) {
                    overallSuccess = false;
                }
            }
            if (self.rizonConnectInternalFields) {
                self.clearRizonInternalErrMsg();
                if (!self.validateRizonConnectInternalFields()) {
                    overallSuccess = false;
                }
            }

            if (overallSuccess) {
                self.saveRizonFields();
            } else {
                self.errorValidationFocus();
            }
        },
        clearRDRInternalErrMsg() {
            this.rdrVerificationDateErrMsg = '';
            this.rdrInternalIncentiveProgramErrMsg = '';
            this.rdrInternalProgramNameErrMsg = '';
            this.rdrInternalProgramNumberErrMsg = '';
        },
        clearRizonLogErrMsg() {
            this.rizonLogCompanyNameErrMsg = '';
            this.rizonLogCustomerNameErrMsg = '';
            this.rizonLogSignatureCollectedErrMsg = '';
            this.rizonLogCustomerEmailErrMsg = '';
            this.rizonLogCustomerPhoneErrMsg = '';
            this.rizonLogDateSignedErrMsg = '';
            this.rizonLogDocumentLinkErrMsg = '';
            this.rizonLogRegDateErrMsg = '';
            this.rizonLogExpDateErrMsg = '';
        },
        clearRizonInternalErrMsg() {
            this.rizonConnectVerificationDateErrMsg = '';
            this.rizonConnectCustAdminErrMsg = '';
        },
        validateRDRInternalFields() {
            var self = this;
            var success = true;

            if (self.rdrVerificationDate == '' || self.rdrVerificationDate == null) {
                self.rdrVerificationDateErrMsg = 'Verification Date is required.';
                success = false;
            }
            if (self.rdrInternalIncentiveProgram == '') {
                self.rdrInternalIncentiveProgramErrMsg = 'Incentive Program Used is required.';
                success = false;
            }
            if (self.rdrInternalProgramName == '') {
                self.rdrInternalProgramNameErrMsg = 'Program Name is required.';
                success = false;
            }
            if (self.rdrInternalProgramNumber == '') {
                self.rdrInternalProgramNumberErrMsg = 'Program Number is required.';
                success = false;
            }

            return success;
        },
        validateRizonConnectLogFields() {
            var self = this;
            var success = true;

            if (self.rizonLogCompanyName == '') {
                self.rizonLogCompanyNameErrMsg = 'Company Name is required.';
                success = false;
            }
            if (self.rizonLogCustomerName == '') {
                self.rizonLogCustomerNameErrMsg = 'Customer Name is required.';
                success = false;
            }
            if (self.rizonLogSignatureCollected == '' || self.rizonLogSignatureCollected == null) {
                self.rizonLogSignatureCollectedErrMsg = 'Signature Collected is required.';
                success = false;
            }
            if (self.rizonLogCustomerEmail == '') {
                self.rizonLogCustomerEmailErrMsg = 'Customer Email is required.';
                success = false;
            } else {
                if (!self.validEmail(self.rizonLogCustomerEmail)) {
                    self.rizonLogCustomerEmailErrMsg = 'Invalid Email Address.';
                    success = false;
                }
            }
            if (self.rizonLogCustomerPhone == '') {
                self.rizonLogCustomerPhoneErrMsg = 'Customer Phone is required.';
                success = false;
            } else {
                var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if (!self.rizonLogCustomerPhone.match(phoneRE)) {
                    self.rizonLogCustomerPhoneErrMsg = "Please enter valid phone number";
                    success = false;
                }
            }
            if (self.rizonLogDateSigned == '' || self.rizonLogDateSigned == null) {
                self.rizonLogDateSignedErrMsg = 'Date Signed is required.';
                success = false;
            }
            if (self.rizonLogDocumentLink == '') {
                self.rizonLogDocumentLinkErrMsg = 'Document Link is required.';
                success = false;
            } else if (!self.isValidUrl(self.rizonLogDocumentLink)) {
                self.rizonLogDocumentLinkErrMsg = 'Invalid Document Link.';
                success = false;
            }
            if (self.rizonLogRegDate == '' || self.rizonLogRegDate == null) {
                self.rizonLogRegDateErrMsg = 'Reg Date is required.';
                success = false;
            }
            if (self.rizonLogExpDate == '' || self.rizonLogExpDate == null) {
                self.rizonLogExpDateErrMsg = 'Exp Date is required.';
                success = false;
            }

            return success;
        },
        isValidUrl(url) {
            const pattern = /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/i;
            return pattern.test(url);
        },
        validateRizonConnectInternalFields() {
            var self = this;
            var success = true;

            if (self.rizonConnectVerificationDate == '' || self.rizonConnectVerificationDate == null) {
                self.rizonConnectVerificationDateErrMsg = 'Verification Date is required.';
                success = false;
            }
            if (self.rizonConnectCustAdmin == '') {
                self.rizonConnectCustAdminErrMsg = 'Cust Admin is required.';
                success = false;
            }

            return success;
        },
        saveRizonFields() {
            var self = this;
            self.loading = true;

            var formData = self.generateRizonFormData();
            $.ajax({
                url: process.env.ROOT_API + "/retail-delivery-report/store-internal",
                type: "POST",
                headers: this.ajxHeaders,
                data: formData,
                contentType: false,
                processData: false,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == 'success') {
                        self.$swal({
                            title: "Retail Delivery Report Successfully Updated.",
                            type: "success",
                            showCloseButton: true,
                        }).then(result => {
                            self.$router.push('/retail-delivery-report/list');
                        });
                    }
                },
                error: function (jqXHR) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'save-rizon-fields');
                }
            });
        },
        loadSingleReport() {
            var self = this;
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/retail-delivery-report/" + self.reportId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == 'success') {
                        var report = data.content;

                        self.date = moment(report.created_at).format('MM/DD/YYYY');
                        self.modelYear = report.model_year;
                        self.model = report.model;
                        self.wheelBaseLength = report.wheel_base_length;
                        self.vin = report.assigned_vehicle ? report.assigned_vehicle.vin : '';
                        self.deliveryDate = moment(report.delivery_date).format('MM/DD/YYYY');
                        self.odometer = report.odometer;
                        self.bodyType = report.body_type;
                        self.primaryBodyBuilderName = report.primary_body_builder_name;
                        self.rizonConnectAuthorization = report.rizon_connect_authorization == 1 ? 'Yes' : 'No';

                        self.companyName = report.assigned_customer && report.assigned_customer.billing_address
                            ? report.assigned_customer.billing_address.company_name : '';
                        self.businessType = report.business_type;
                        self.customerName = report.assigned_customer ? report.assigned_customer.name : '';
                        self.customerAddress = report.assigned_customer ? report.assigned_customer.address_line_one : '';
                        self.customerCity = report.assigned_customer && report.assigned_customer.city ? report.assigned_customer.city.name : '';
                        self.customerState = report.assigned_customer && report.assigned_customer.state ? report.assigned_customer.state.name : '';
                        self.customerZip = report.assigned_customer ? report.assigned_customer.postcode : '';
                        self.customerEmail = report.assigned_customer ? report.assigned_customer.email : '';
                        self.customerPhoneNumber = report.assigned_customer ? report.assigned_customer.phone_no : '';

                        self.dealerCode = report.assigned_dealer ? report.assigned_dealer.code : '';
                        self.dealerName = report.assigned_dealer ? report.assigned_dealer.name : '';
                        self.dealerAddress = report.assigned_dealer ? report.assigned_dealer.address_line_1 : '';
                        self.dealerCity = report.assigned_dealer && report.assigned_dealer.city ? report.assigned_dealer.city.name : '';
                        self.dealerState = report.assigned_dealer && report.assigned_dealer.state ? report.assigned_dealer.state.name : '';
                        self.dealerZip = report.assigned_dealer ? report.assigned_dealer.postcode : '';
                        self.salespersonFirstName = report.salesperson_first_name || '';
                        self.salespersonLastName = report.salesperson_last_name || '';
                        self.salespersonEmail = report.salesperson_email || '';
                        self.salespersonPhoneNumber = report.salesperson_phone_number || '';

                        self.reportInternalId = report.linked_rizon_internal ? report.linked_rizon_internal.id : 0;
                        self.populateRizonFields(report);
                    }
                },
                error: function (jqXHR) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'load-single-report');
                }
            });
        },
        populateRizonFields(report) {
            var self = this;

            const linkedRizonInternal = report.linked_rizon_internal || {};
            // rdr internal fields
            self.rdrInternalVerifiedBy = linkedRizonInternal.rdr_verified_by
                ? linkedRizonInternal.rdr_verified_by.email || linkedRizonInternal.rdr_verified_by.username
                : this.userObj.email || this.userObj.username;
            self.rdrVerificationDate = linkedRizonInternal.rdr_verification_date
                ? moment(linkedRizonInternal.rdr_verification_date).format('MM/DD/YYYY')
                : moment().format('MM/DD/YYYY');
            self.rdrInternalIncentiveProgram = linkedRizonInternal.incentive_program_used == 1
                ? 'Yes'
                : linkedRizonInternal.incentive_program_used == 0
                    ? 'No' : '';
            self.rdrInternalProgramName = linkedRizonInternal.program_name || '';
            self.rdrInternalProgramNumber = linkedRizonInternal.program_number || '';

            // rizon connect log
            self.rizonLogCompanyName = linkedRizonInternal.company_name || '';
            self.rizonLogCustomerName = linkedRizonInternal.customer_name || '';
            self.rizonLogSignatureCollected = linkedRizonInternal.signature_collected == 1
                ? 'Yes'
                : linkedRizonInternal.signature_collected == 0
                    ? 'No' : '';
            self.rizonLogCustomerEmail = linkedRizonInternal.customer_email || '';
            self.rizonLogCustomerPhone = linkedRizonInternal.customer_phone || '';
            self.rizonLogDateSigned = linkedRizonInternal.date_signed
                ? moment(linkedRizonInternal.date_signed).format('MM/DD/YYYY')
                : moment().format('MM/DD/YYYY');
            self.rizonLogDocumentLink = linkedRizonInternal.document_link || '';
            self.rizonLogRegDate = linkedRizonInternal.reg_date
                ? moment(linkedRizonInternal.reg_date).format('MM/DD/YYYY')
                : moment().format('MM/DD/YYYY');
            self.rizonLogExpDate = linkedRizonInternal.exp_date
                ? moment(linkedRizonInternal.exp_date).format('MM/DD/YYYY')
                : moment().format('MM/DD/YYYY');

            // rizon connect internal fields
            self.rizonConnectVerifiedBy = linkedRizonInternal.rizon_verified_by
                ? linkedRizonInternal.rizon_verified_by.email || linkedRizonInternal.rizon_verified_by.username
                : this.userObj.email || this.userObj.username;
            self.rizonConnectVerificationDate = linkedRizonInternal.rizon_connect_verification_date
                ? moment(linkedRizonInternal.rizon_connect_verification_date).format('MM/DD/YYYY')
                : moment().format('MM/DD/YYYY');
            self.rizonConnectCustAdmin = linkedRizonInternal.cust_admin || '';
        },
        generateRizonFormData() {
            var self = this;
            var formData = new FormData();

            if (self.rdrInternalFields) {
                formData.append('rdr_verified_by', self.userObj.id);
                formData.append('rdr_verification_date', moment(self.rdrVerificationDate).format('YYYY-MM-DD'));
                formData.append('incentive_program_used', self.rdrInternalIncentiveProgram == 'Yes' ? 1 : 0);
                formData.append('program_name', self.rdrInternalProgramName);
                formData.append('program_number', self.rdrInternalProgramNumber);
            }
            if (self.rizonConnectLogFields) {
                formData.append('company_name', self.rizonLogCompanyName);
                formData.append('customer_name', self.rizonLogCustomerName);
                formData.append('signature_collected', self.rizonLogSignatureCollected === 'Yes' ? 1 : 0);
                formData.append('customer_email', self.rizonLogCustomerEmail);
                formData.append('customer_phone', self.rizonLogCustomerPhone);
                formData.append('date_signed', moment(self.rizonLogDateSigned).format('YYYY-MM-DD'));
                formData.append('document_link', self.rizonLogDocumentLink);
                formData.append('reg_date', moment(self.rizonLogRegDate).format('YYYY-MM-DD'));
                formData.append('exp_date', moment(self.rizonLogExpDate).format('YYYY-MM-DD'));
            }
            if (self.rizonConnectInternalFields) {
                formData.append('rizon_verified_by', self.userObj.id);
                formData.append('rizon_connect_verification_date', moment(self.rizonConnectVerificationDate).format('YYYY-MM-DD'));
                formData.append('cust_admin', self.rizonConnectCustAdmin);
            }
            formData.append('internal_report_id', self.reportInternalId);
            formData.append('report_id', self.reportId);

            return formData;
        },
        sendEmailNotification() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/retail-delivery-report/send-email-notification/" + self.reportId,
                type: "GET",
                headers: this.ajxHeaders,
                success: function (data) {
                    self.loading = false;
                    self.thankYouSwalPopUp();
                },
                error: function (jqXHR) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'send-email-notification');
                }
            });
        }
    },
};
</script>
<style scoped>
.loader-vvg {
    z-index: 1063;
}
</style>



// WEBPACK FOOTER //
// src/components/retailDeliveryReport/RetailDeliveryReportCreate.vue